import type { User } from '@repo-level/core-front';
import { addPlayerGroups } from 'api/auth';
import type { CmsABTest } from 'api/cms/abTests';
import { sendOtherABTestAssignmentEvent } from 'modules/googleAnalytics/events/otherEvents';
import type { ABTestVersion } from '../types';
import { ABTestingStore } from './abTestStorage';
import { checkAbTestVersion } from './checkAbTestVersion';
import { getRandomABTestVersion } from './getRandomABTestVersion';

export interface AssignABTestVersionParams {
  experiment: string;
  cmsABTests: CmsABTest[];
  versions: ABTestVersion[];
  user?: User;
  refreshUser: () => Promise<User | void>;
}

export const assignABTestVersion = (params: AssignABTestVersionParams) => {
  const existingVersion = checkAbTestVersion(params);

  if (existingVersion) return existingVersion;

  const newVersion = getRandomABTestVersion(params.versions);
  if (!newVersion) return;

  ABTestingStore(params.experiment).replace({ name: newVersion.name });

  if (params.user) {
    addPlayerGroups([newVersion.name])
      .then(() => params.refreshUser())
      .catch((err) => console.error('addPlayerGroups failed:', err));
  }

  const parts = newVersion.name.split(':');

  sendOtherABTestAssignmentEvent({
    test_name: params.experiment,
    test_group: newVersion.name,
    test_version: parts[parts.length - 1],
  });
  return newVersion.name;
};
